import axios from "axios";
import getAuthorizationToken from "../authToken";
import store from "../../store";

const loading = "SET_LOADING";
const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

instance.interceptors.request.use(
  config => {
    store.commit(loading, true);
    let token = getAuthorizationToken();
    if (token) config.headers.Authorization = token;
    return config;
  },
  err => {
    store.commit(loading, !true);
    return Promise.reject(err);
  }
);
instance.interceptors.response.use(
  response => {
    store.commit(loading, !true);
    store.commit('SET_AUTHERROR', null);
    return response;
  },
  err => {
    store.commit(loading, !true);
    if(err.response.status == 403) {
      store.commit('SET_AUTHERROR', 'Unauthorized');
    }
    else if(err.response.status == 469) {
      store.commit('SET_AUTHERROR', err.response.data.message);
    }
    else if(err.response.status == 440) {
      store.commit('SET_AUTHERROR', 'Sesi login Anda telah berakhir. Silakan login kembali!');
    }
    return Promise.reject(err);
  }
);
export default instance;